import { connect } from "react-redux"

import { FeedRejectionReasonModal } from "../../common/FeedRejectionReasonModal"
import {
    addFeedModerate,
    addFeedToggleRejectionReasonModal
} from "../../../actions/add-feed-actions"

const mapDispatchToProps = dispatch => ({
    toggle: () => dispatch(addFeedToggleRejectionReasonModal()),
    reject: reason => {
        dispatch(addFeedToggleRejectionReasonModal())
        dispatch(addFeedModerate(false, reason))
    }
})

export default connect(null, mapDispatchToProps)(FeedRejectionReasonModal)
